'use strict';

var actions = require('../actions'),
    lang = require('../../lang');

module.exports = [
    [
        {value: '123', action: actions.numericKeyboard},
        '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '(', ')',
        {className: 'backspace', action: actions.backspace, value: ''}
    ],
    [
        {value: '#&$', action: actions.symbolsKeyboard},
        'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'ç', ':',
        {value: 'Limpieza', action: actions.clear}
    ],
    [
        {className: 'uppercase', action: actions.uppercase, value: ''},
        'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'ñ', '`', ';',
        {value: 'Listo', action: actions.done, className: 'yellowText'}
    ],
    [
        {value: lang.shortNames[lang.active], action: actions.changeLanguage, rowSpan: 2, className: 'lang'},
        '@', 'z', 'x', 'c', 'v', 'b', 'n', 'm', '!', '%', '?', '-',
        {value: 'Cancelación', action: actions.cancel, className: 'cancel'}
    ],
    [
        ',', '.', '/',
        {value: 'Brecha', action: actions.space, colSpan: 5, className: 'blueText'},
        '_',
        {value: '', action: actions.moveCaretToLeft, className: 'arrow left'},
        {value: '', action: actions.moveCaretToRight, className: 'arrow right'},
        {value: '', action: actions.moveCaretToStart, className: 'arrow start'},
        {value: '', action: actions.moveCaretToEnd, className: 'arrow end'}
    ]
];
